module.exports = __webpack_public_path__ + "img/l-hd.c995e660.jpg";